import { supabase } from './supabaseClient';

// A estrutura territorial agora vive no mesmo Supabase da operação. Este alias
// preserva o contrato dos serviços durante a transição sem criar transporte,
// autenticação ou armazenamento de sessão adicionais.
export const migrationSupabase = supabase;
